import { ButtonSuccessStyle } from '../styles'
import { SendPvButtonHook } from './SendPvButton.hook'

const SendPvButton = () => {
  const { handleClickSendPv, isEnableSendPvButton, isLoading } = SendPvButtonHook()

  return (
    isEnableSendPvButton && (
      <ButtonSuccessStyle onClick={handleClickSendPv} loading={isLoading}>
        ส่ง PV
      </ButtonSuccessStyle>
    )
  )
}

export default SendPvButton
